import PropTypes from 'prop-types';
import React from 'react';
import SearchField from '../../controls/base/SearchField/SearchField';
import propTypes from '../../../../common/propTypes';
import translatePropTypes from '../../../translatePropTypes';
import withTranslations from '../../utils/Translations/withTranslations';

@withTranslations
export default class StaticOverlayTreeDefaultFilter extends React.PureComponent {
  static propTypes = {
    value: PropTypes.shape({
      status: propTypes.status,
      searchQuery: PropTypes.string.isRequired,
    }).isRequired,
    onChange: PropTypes.func,
    ...translatePropTypes,
  };

  static defaultProps = {
    onChange: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchQuery: this.props.value.searchQuery,
    };
  }

  handleChange = filters => {
    const { value, onChange } = this.props;
    onChange && onChange({ ...value, ...filters });
  };

  handleSearchChange = searchQuery => {
    this.setState({ searchQuery });

    const { value, onChange } = this.props;
    onChange && onChange({ ...value, searchQuery });
  };

  handleSearchInputFocus = searchContainerInput => {
    if (!searchContainerInput) {
      return;
    }

    const input = searchContainerInput.getElementsByTagName('input')[0];
    input && input.focus();
  };

  render() {
    const { t } = this.props;
    const { searchQuery } = this.state;

    return (
      <div ref={this.handleSearchInputFocus}>
        <SearchField
          placeholder={t('Search')}
          value={searchQuery}
          onChange={this.handleSearchChange}
        />
      </div>
    );
  }
}
